import Buefy from 'buefy'

export const buefyOptions = {
  defaultIconPack: 'fas',
  defaultCompatFallthrough: false,
}

export default Buefy
